import { addDoc, collection } from "@firebase/firestore"
import { showErrorSnackbar, showSuccessSnackbar } from "../../../shared/snackbar/snackbar-slice";
import { addTypes } from "../item-types-list/item-types-list-slice";
import { hideLoading, showLoading } from "./item-types-add-slice";

export const addItemTypesService = async (dispatch, db, coll, formData) => {
    dispatch(showLoading());
    try {
        const docRef = await addDoc(collection(db, coll), formData);
        dispatch(addTypes({
            id: docRef.id,
            ...formData
        }));
        dispatch(showSuccessSnackbar('Added successfully!'));
    } catch(e) {
        dispatch(showErrorSnackbar('Add failed! Please try again.'))
        console.error("ItemTypesAdd addItemTypesService error: ", e);
    }
    dispatch(hideLoading());
};